import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Thin determinate-style loader bar. A grey track with a teal fill that animates
 * from 0% to 100% over `durationMs` (default 2500ms) via a CSS keyframe — no JS
 * timer, no zone churn. Restarts whenever the component re-mounts. Sized
 * 130×2 by design; visual style is fixed because the only consumer today is
 * the follow-up questions widget's "Loading…" placeholder. Add inputs for
 * size/colour when a second consumer needs them.
 */
@Component({
  selector: 'app-linear-loader-bar',
  templateUrl: './linear-loader-bar.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinearLoaderBarComponent {
  readonly durationMs = input<number>(2500);
}
